import type { FunctionComponent } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"
import { ElementGrid } from "@jobteaser/ui-kit/components/ElementGrid/ElementGrid"
import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/dist/module/components/Layout/Layout"

import { COMPANY_PAGE_TYPE } from "@/modules/companies/client/api/endpoints/company"
import { ContractCard } from "@/modules/companies/client/components/RecruitmentPatternInformation/ContractCard/ContractCard"
import { MonthCard } from "@/modules/companies/client/components/RecruitmentPatternInformation/MonthCard/MonthCard"
import { SectorCard } from "@/modules/companies/client/components/RecruitmentPatternInformation/SectorCard/SectorCard"
import { useCompanyAnalyticsData } from "@/modules/companies/client/components/RecruitmentPatternInformation/useCompanyAnalyticsData"
import { PUBLICATION_MONTH_THRESHOLD } from "@/modules/companies/client/components/RecruitmentPatternInformation/utils/analyticsUtils"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./RecruitmentPatternInformation.module.css"

export const RECRUITMENT_PATTERN_ID = "recruitment-pattern-information"

export const RecruitmentPatternInformation: FunctionComponent = () => {
  const { t } = useTranslation(["companies_client"])
  const { dataCompany } = useCompanyFetch()
  const { hasEnoughData } = useCompanyAnalyticsData()
  const premiumCompany = dataCompany?.pageType === COMPANY_PAGE_TYPE.PREMIUM

  if (!premiumCompany) return null
  if (!hasEnoughData) return null

  return (
    <Layout
      hasTopPadding
      hasBottomPadding
      colorBlock={LAYOUT_COLOR_BLOCK.BLACK}
      id={RECRUITMENT_PATTERN_ID}
      data-testid="recruitementPattern"
    >
      <Layout.Column>
        <Heading as="h2" variant="title2" weight="bold" className={styles.recruitementPatternInformation__title}>
          {t("companies_client.recruitmentPatternInformation.stats.title", {
            length: PUBLICATION_MONTH_THRESHOLD,
            name: dataCompany.page.name,
          })}
        </Heading>
        <ElementGrid>
          <ContractCard />
          <SectorCard />
          <MonthCard />
        </ElementGrid>
      </Layout.Column>
    </Layout>
  )
}
